import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom'
import * as actions from "../../../store/actions";
import EnhancedTableHead from "../../../UI/MaterialTableOverrides/EnhancedTableHead";
import TablePaginationActionsWrapped from "../../../UI/MaterialTableOverrides/TablePaginationActions";
import TableTitle from '../../../UI/MaterialTableOverrides/TableTitle';

import {
  Paper, Typography, Table, TableRow, TableCell, TableFooter, TableBody, CircularProgress, TablePagination
} from '@mui/material';
import ModalUsers from './Modals/ModalUsers';

import { roleNames } from '../../../utils/roleNames';

const TenantDetails = (props) => {

  const dispatch = useDispatch();
  let textInput = useRef(null);

  const [page, setPage] = useState(1);
  const [alreadySerched, setAlreadySerched] = useState(false);
  const [limit, setLimit] = useState(5);
  const [searchText, setSearchText] = useState("");
  const [orderBy, setOrderBy] = useState("name");
  const [order, setOrder] = useState("asc");
  const [userId, setUserId] = useState('new');
  const [open, setOpen] = useState(false);

  const fetchUsers = useCallback(
    () => dispatch(actions.fetchUsersByTenant(props.match.params.id, page, limit, searchText, order, orderBy)),
    [page, limit, searchText, order, orderBy]
  );

  const users = useSelector(state => state.users.users);
  const loading = useSelector(state => state.users.loading);

  const headRows = [
    { id: "name", numeric: false, disablePadding: false, label: "Usuarios" },
    { id: "role", numeric: false, disablePadding: false, label: "Função" },
  ];

  useEffect(() => {
    fetchUsers(page, limit, searchText, order, orderBy);
    setAlreadySerched(true);
  }, [page, limit, order, orderBy]);

  useEffect(() => {
    if (searchText !== "" || alreadySerched) {
      const timer = setTimeout(() => {
        if (searchText === textInput.current.value) {
          fetchUsers(page, limit, searchText, order, orderBy);
        }
      }, 200);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [searchText, textInput]);

  const handleChangePage = (e, page) => {
    setPage(page + 1);
  };

  const handleChangeRowsPerPage = e => {
    setLimit(e.target.value);
    setPage(1);
  };

  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === property && order === "desc";
    setOrder(isDesc ? "asc" : "desc");
    setOrderBy(property);
  };

  const styles = {
    table: {
      position: 'relative',
    },
    tableRow: {
      cursor: 'pointer',
    },
    opacityContainer: {
      opacity: loading ? '0.3' : '1',
    },
    spinner: {
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      top: '-5px',
      opacity: '1',
      zIndex: 2,
    },
    noResults: {
      height: '100px',
    },
    deleteTextConfirm: {
      marginLeft: '-30px',
      fontWeight: 'bold',
    },
    editWidth: {
      width: '90%'
    }
  }

  return <>
    <ModalUsers
      userId={userId}
      open={open}
      onClose={() => setOpen(false)}
      tenantId={props.match.params.id}
    />
    <Paper style={styles.paper}>
      <TableTitle
        title='Usuários'
        placeholder='Pesquisar por usuarios'
        inputRef={textInput}
        value={searchText}
        onChange={event => {
          setPage(1);
          setSearchText(event.target.value);
        }}
        addRow={() => {
          setUserId('new');
          setOpen(true);
        }}
      />
      <Table style={styles.table}>
        <tbody>
          <tr>
            <td>
              {loading &&
                <div style={styles.spinner}>
                  <CircularProgress />
                </div>}
              {users.rows.length === 0 &&
                <div style={styles.noResults}>
                  {!loading && <Typography style={styles.spinner}>Nenhum resultado encontrado</Typography>}
                </div>}
            </td>
          </tr>
        </tbody>
        <EnhancedTableHead
          style={styles.opacityContainer}
          headRows={headRows}
          order={order}
          orderBy={orderBy}
          onRequestSort={handleRequestSort}
        />
        <TableBody style={styles.opacityContainer}>
          {users.rows.map((user, index) => (
            <TableRow key={user._id}
              onClick={() => {
                setUserId(user._id);
                setOpen(true);
              }}
              style={styles.tableRow}
            >
              <TableCell>{user.name}</TableCell>
              <TableCell>{user.access.map(acc => roleNames(acc.role))}</TableCell>
            </TableRow>
          ))}
        </TableBody>
        <TableFooter style={styles.opacityContainer}>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              count={users.count}
              rowsPerPage={parseInt(limit)}
              page={page - 1}
              SelectProps={{
                native: true
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActionsWrapped}
            />
          </TableRow>
        </TableFooter>
      </Table>

    </Paper>
  </>;
}

export default withRouter(TenantDetails);

